const MONTHS = ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru']
const MONTHS_FULL = ['stycznia', 'lutego', 'marca', 'kwietnia', 'maja', 'czerwca', 'lipca', 'sierpnia', 'września', 'października', 'listopada', 'grudnia']
const DAY = 864e5
const pad = (n) => (n < 10 ? '0' : '') + n
export const dayKey = (d) => `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`
export const time = (value) => { const d = new Date(value); return `${pad(d.getHours())}:${pad(d.getMinutes())}` }

// Lista: dziś — godzina, „wczoraj”, w tym roku „12 paź”, starsze z rokiem.
export function shortDate (value, now = new Date()) {
    const d = new Date(value)
    if (Number.isNaN(d.getTime())) return ''
    if (dayKey(d) === dayKey(now)) return time(d)
    if (dayKey(d) === dayKey(new Date(now.getTime() - DAY))) return 'wczoraj'
    if (d.getFullYear() === now.getFullYear()) return `${d.getDate()} ${MONTHS[d.getMonth()]}`
    return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}`
}

// Separator dni w rozmowie: „Dziś”, „Wczoraj”, „12 października [2025]”.
export function dayLabel (value, now = new Date()) {
    const d = new Date(value)
    if (dayKey(d) === dayKey(now)) return 'Dziś'
    if (dayKey(d) === dayKey(new Date(now.getTime() - DAY))) return 'Wczoraj'
    return `${d.getDate()} ${MONTHS_FULL[d.getMonth()]}${d.getFullYear() !== now.getFullYear() ? ' ' + d.getFullYear() : ''}`
}

export function plural (n, one, few, many) {
    if (n === 1) return one
    const u = n % 10, t = n % 100
    return u >= 2 && u <= 4 && (t < 12 || t > 14) ? few : many
}
